import React, { useState, useEffect, useRef } from "react";
import secureStorage from "./utils/secureStorage";
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/team";
import Invoices from "./scenes/invoices";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import Work from "./queries/works";
import Registration from "./registration";
import Queries from "./queries";
import Activity from "./registration/activity";
import Owner from "./registration/owner";
// import OwnerQuery from "./queries/owners";
import { Login } from "./login";
// import Inventario from "./queries/inventario/index";
// import useFetchDataPeriodically from "./customHooks/autoClave";
import useInactivityTimeout from "./customHooks/inactivityHook";
import ProtectedRoute from "./components/ProtectedRoute";
// import Products from "./registration/Products";
// import Truks from "./queries/list Truk";
// import Hangar2 from "./queries/Pantallas/hangar2";
// import Hangar1 from "./queries/Pantallas/hangar1";
// import Porteria from "./queries/Pantallas/porteria";
// import Portero from "./queries/porteria view";
// import Camiones from "./registration/camiones";
import Dracena from "./dracena/dracena";
import Resumen from "./queries/resumen/index";
import Nomina from "./queries/nomina/index";
import Grupos from "./registration/grupos";
import Salarios from "./registration/salarios";
import Horarios from "./registration/horarios";
import ListaMarcaciones from "./queries/resumen/lista marcaciones";
import RegistroDescuento from "./registration/descuento";
import RegistroAdelanto from "./registration/adelanto";
import DescuentoView from "./queries/descuento";
import HorasExtras from "./queries/horasExtras";
import HorariosView from "./queries/horarios";
import GruposView from "./queries/grupos";
import Salariosview from "./queries/salarios";
import Usuarioview from "./queries/usuarios";
import HorasExtrasR from "./registration/horasExtras";
import PlusView from "./queries/plus";
import MetasView from "./queries/metas";
import MetasR from "./registration/metas";
import Calandra from "./registration/calandra";
import Interfoliacion from "./registration/interfoliacion";
import Graficos from "./scenes/graficos";
import ReporteCalandra from "./queries/reporteCalandra";
import ReporteDescarga from "./queries/reporteDescarga";
import ReporteLavadora from "./queries/reporteLavadora";
import ReporteSalaLimpia from "./queries/reporteSalaLimpia";
// import ReporteviewInterView from "./queries/reporteInterView";
import ReporteviewStock from "./queries/reporteStock";
import ReporteviewCalandra from "./queries/reporteCalandra";
import LavadoraCalandraView from "./queries/LavadoraCalandraView";
import CalandraInterfoliacionView from "./queries/CalandraInterfoliacionView";
import ReporteviewInter from "./queries/reporteInterView";
import Stock from "./registration/stock";
import ReporteStock from "./registration/reporteStock";
import ReporteCalandrar from "./registration/reporteCalandra";
import ReporteDescargar from "./registration/reporteDescarga";
import ReporteLavadorar from "./registration/reporteLavadora";
import ReporteSalaLimpiar from "./registration/reporteSalaLimpia";
import ReporteInterfoliacion from "./registration/reporteInterfoliacion";
import ProduccionPie from "./components/ProduccionPie";
import CalandraRegistroView from "./queries/Calandra Registro View";
import OrdenProduccionView from "./queries/ordenProduccionView";
// import CalandrTest from "./registration/calandratestticket";
import Productos from "./registration/productos";
import Loading from "./loadingSpinner/refresh";
// import '@fortawesome/fontawesome-free/css/all.min.css';
import InterfoliacionR from "./registration/interfoliacion";
import Aprovechamiento from "./registration/aprovechamiento";
import Ventas from "./registration/ventas";
import OrdenProduccion from "./registration/ordenProduccion";
import Proveedor from "./registration/proveedor";
import Pagos from "./registration/pagos";
import Permisos from "./registration/permisos";
import Notificación from "./registration/notificación";
import Banco from "./registration/banco";
import NumeroSerie from "./queries/numeroSerie";
import AguinaldoIps from "./queries/aguinaldoIps";
import AguinaldoInterno from "./queries/aguinaldo Interno";
import PagosView from "./queries/pagos";
import PermisosView from "./queries/permisos";
import BancoView from "./queries/banco";
import LiquidationView from "./queries/liquidation";
import VacacionesView from "./queries/vacaciones";
import AdelantoView from "./queries/adelanto";
import LoadingBar from 'react-top-loading-bar';
import TopLoadingBar from "./loadingSpinner/topLoading";
import Lavadora from "./queries/lavadora";
import SalaLimpia from "./queries/salalimpia";
import StockView from "./queries/stock";
import StockMonoliticoView from "./queries/stock/stockMonolitico";
import StockLaminadoView from "./queries/stock/stockLaminado.jsx";
import StockPVBView from "./queries/stock/stockPVB";
import CalandraTrue from "./queries/calandraTrue";
import CalandraDatosProductos from "./queries/calandraDatosProductos";
import PVB from "./registration/pvb";
import Vehiculo from "./registration/vehiculo";
import Caballete from "./registration/caballete";
import Cliente from "./registration/cliente";
import EntradaNotaFiscal from "./registration/entradaNotaFiscal";
import PvbNotaFiscal from "./registration/pvbNotaFiscal";
import { ToastContainer } from 'react-toastify';
import LiberarStock from "./queries/liberarStock";
import NotasFiscales from "./queries/notasFiscales";
import Quiebra from "./registration/quiebra";
import AntiguoRp from "./queries/rpInterBase64";
import Translados from "./queries/translados";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Descarga from "./registration/descarga";
import Transferencia from "./registration/transferenciaEmpresas";
import TransladoChapas from "./registration/transladoChapa";
import Receta from "./registration/receta";
import QuiebraV from "./queries/quiebra";
import SalaLimpiaT from "./registration/salaLimpia";
import SalaLimpiaView from "./queries/salaLimpiaT";
import ExportacionZD from "./registration/contabilidad/facturacion";
import ExportacionA from "./registration/contabilidad/facturacion/FacturaArgentina";
import AutoClave from "./registration/autoClave";
import AutoClaveView from "./queries/autoclave";
import SalidaAutoClave from "./registration/salidaAutoClave";
import AccesoEventos from "./registration/accesoEventos";
import HistorialVentas from "./queries/historial_venta/index.jsx";
import PedidoVenta from "./registration/pedidoVenta";
import Precio from "./registration/precio";
import PrecioView from "./queries/listaPrecio";
import Historial from "././queries/historial";
import LiberarFinanciero from "././queries/liberarFinanciero";
import LiberarCamiones from "././queries/liberarCamiones";
import OrdenCarga from "./queries/ordenCarga";
import OrdenCargaDetalle from "./queries/ordenCarga/detalle";
import OrdenCargaListado from "./queries/ordenCarga/listado";
import Cargamento from "./queries/cargamento";
import Contratos from "./queries/contratos";
import ExportacionVentana from "./registration/contabilidad/ventana/index.jsx";
import Palitero from "./queries/palitero/index.jsx";
import StockCaballete from "./queries/stockCaballete/index.jsx";
import ListaProducto from "./queries/producto/index.jsx";
import HistorialChapa from "./queries/historialChapa/index.jsx";
import StockCoinvertir from "./queries/stock/stockCoinvertir.jsx";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Reembalar from "./queries/reembalar";
import ProductosTejidos from "./registration/productosTejidos/productosTejidos.jsx";
import MaquinasTejido from "./registration/maquinasTejido/maquinasTejido.jsx";
import StockTejido from "./registration/stockTejido/stockTejido.jsx";
import TejidoEspera from "./queries/tejidos/tejidosespera.jsx";
import TrasladoTejido from "./registration/traslado/trasladoTejidoEspera.jsx";
import PedidoVentaTejido from "./registration/pedidoVentaTejido/pedidoVentaTejido.jsx";
import CargamentoTejido from "./queries/cargamentoTejido/index.jsx";
import LiberarTejido from "./queries/liberarTejido/index.jsx";
import TejidoenStock from "./queries/tejidos/stocktejido.jsx";
import HistorialVentasTejido from "./queries/historial_ventaTejido/index.jsx";
import RolloGeneral from "./queries/tejidos/stockgeneral.jsx";
import TransladoLaboratorio from "./registration/transladoLaboratorio/index.jsx";
import StockEvoluaco from "./queries/tejidos/stockEvoluaco.jsx";
import ProductosAmoxarifado from "./registration/amoxarifado/producto.jsx";
import Estante from "./registration/estante/index.jsx";
import Fila from "./registration/fila/index.jsx";
import Columna from "./registration/columna/index.jsx";
import Categoriasamoxarifado from "./registration/amoxarifado/categorias.jsx";
import SubCategoriasamoxarifado from "./registration/amoxarifado/subcategorias.jsx";
import Depositosamoxarifado from "./registration/amoxarifado/depositos.jsx";
import ProduccionTejido from "./queries/tejidos/produccion.jsx";
import ProduccionFuncTejido from "./queries/tejidos/produccionf.jsx";
import ProductosViewAmoxarifado from "./queries/amoxarifado/productos.jsx";
import OrdenTejido from "./registration/ordenTejido/ordenTejido.jsx";
import ProduccionRolos from "./registration/ordenTejido/produccion.jsx";
import EditProducto from "./registration/amoxarifado/editarproducto.jsx";
import StockAmoxarifado from "./queries/amoxarifado/stock.jsx";
import PrestamoAmoxarifado from "./queries/amoxarifado/prestamos.jsx";
import Adicional from "./queries/adicional/adicional.jsx";
import StockDeposito from "./registration/stockDeposito/index.jsx";
import SalidaProduct from "./registration/amoxarifado/salidaProduct.jsx";
import DevolucionDeposito from "./registration/devolucionDeposito/index.jsx";
import HistorialDeposito from "./queries/amoxarifado/historial.jsx";
import StockMinimoAmoxarifado from "./queries/amoxarifado/stockMinimo.jsx";
import Cargadoresxdxd from "./registration/xd";
import RGraficos from "./queries/relatorioGrafic/index.jsx";
import StockMonoliticoVentasView from "./queries/stock/stockMonoliticoVenta.jsx";
import StockLaminadoVentaView from "./queries/stock/stockLaminadoVenta.jsx";
import ResumenAdelanto from "./queries/adelanto/adelantoView.jsx";
import Feriados from "./scenes/feriados";
import { FeriadosProvider } from './context/FeriadosContext';
import LaboratorioPruebas from "./registration/laboratorioPruebas/index.jsx";
import LaboratorioResultados from "./registration/laboratorioResultados/index.jsx";
import LaboratorioResultadosVista from "./registration/laboratorioResultadosVista/index.jsx";
import InterfoliacionMobile from "./registration/interfoliacionMobile";
import Truck from "./queries/truck";
import Faltas from "./registration/faltas/index.jsx";
import FaltasView from "./queries/faltas/index.jsx";
import SwapHistoryView from "./queries/swapHistory";
import RegistroPlus from "./registration/metas/plus.jsx";
import PermisosUsuario from "./registration/permisosUsuario/index.jsx";
import Patrimonios from "./registration/amoxarifado/patrimonios.jsx";
import ListaMarcacionesExtras from "./queries/resumen/lista marcaciones/marcacion.jsx";
import CvPostulante from "./registration/postulantes/index.jsx";
import CvPostulanteView from "./queries/postulantes/index.jsx";
import RegistroUniforme from "./registration/uniformes/index.jsx";
import RegistroStockUniforme from "./registration/uniformes/stocku.jsx";
import StockUniformesV from "./queries/stockuniformes/index.jsx";
import TopUniformes from "./queries/stockuniformes/top.jsx";
import HistorialAsignacionU from "./queries/stockuniformes/asignacion.jsx";
import Uniformes from "./queries/uniformes/index.jsx";
import RankingProduccion from "./queries/rankingProduccion";
import StockLamExport from "./queries/stock/stockLaminadoExport.jsx";
import AccesoPage from "./queries/acceso";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const location = useLocation();
  const navigate = useNavigate(); // ✅ Usar useNavigate
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const ref = useRef(null);
  const [loading, setLoading] = useState(true); // Estado de carga para evitar renderizado prematuro
  const [isLoading, setIsLoading] = useState(false);
  // useFetchDataPeriodically(); 
  useInactivityTimeout(18000000); 


  useEffect(() => {
    const token = secureStorage.getItem("authToken");

    const isTokenExpired = (token) => {
      if (!token) return true; // Si no hay token, se considera expirado

      try {
        const decoded = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
        return decoded.exp < currentTime; // Retorna true si ya expiró
      } catch (error) {
        return true; // Si hay un error al decodificar, el token es inválido
      }
    };
 
    const checkAuth = () => {
      if (token && !isTokenExpired(token)) {
        setIsAuthenticated(true); // Token válido
      } else {
        setIsAuthenticated(false); // Token inválido o inexistente
        secureStorage.removeItem("authToken"); // Eliminar token expirado
        if (location.pathname !== "/login" && location.pathname !== "/view/rankingProduccion") {
          toast.error(`Token Vencido Vuelve a Iniciar Sesion`, { position: "top-center", autoClose: 9000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true });
        }
        // navigate("/login"); // ✅ Redirigir sin recargar la página
      }
      setLoading(false);
    };

    setTimeout(checkAuth, 2000); // Retraso de 2 segundos

  }, [navigate, location.pathname]); // ✅ Dependencia agregada para evitar bucles infinitos




  // Si estamos cargando, mostramos un loader o mensaje de "Loading..."
  if (loading) { return <TopLoadingBar /> }



  const isLoginRoute = location.pathname === "/login";
  const isHangar1Route = location.pathname === "/hangar1";
  const isHangar2Route = location.pathname === "/hangar2";
  const isPorteriaRoute = location.pathname === "/porteria";
  const isLavadoraRoute = location.pathname === "/lavadora";
  const isSalaLimpia = location.pathname === "/salalimpia";
  const isCalandraTrue = location.pathname === "/calandraTrue";
  const isCalandraDatosProductos = location.pathname === "/calandraDatosProductos";
  const isTransladoChapa = location.pathname === "/registro/transladoChapas";
  const isInterfoliacion = location.pathname === "/registro/interfoliacion";
  const isSalida = location.pathname === "/registro/salidaAutoclave";
  const isDescarga = location.pathname === "/registro/descarga";
  const isTransEmpresa = location.pathname === "/registro/transferenciaEmpresas";
  const isCargamento = location.pathname === "/view/cargamento";
  const isInterMobile = location.pathname === "/registro/interfoliacionMobile";
  const isTransladoLaboratorio = location.pathname === "/registro/transladoLaboratorio";
  const isxd = location.pathname === "/registro/asignacionChapa";
  const rankingProduccion = location.pathname === "/view/rankingProduccion";
  const isDracenaRoute = location.pathname === "/";

  const holidayBackgroundStyle = isDracenaRoute
    ? {
        backgroundImage: "url(/assets/fondoNavidad.jpeg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }
    : undefined;


  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <FeriadosProvider>
        <div className="app" style={holidayBackgroundStyle}>
          {!isLoginRoute && !rankingProduccion && !isAuthenticated && <Navigate to="/login" replace />}
          {!isLoginRoute && !isHangar1Route && !isxd && !isInterMobile && !rankingProduccion && !isTransladoLaboratorio && !isLavadoraRoute && !isCargamento && !isDescarga && !isInterfoliacion && !isTransEmpresa && !isTransladoChapa && !isSalida && !isSalaLimpia && !isCalandraTrue && !isCalandraDatosProductos && !isHangar2Route &&  !isPorteriaRoute && isAuthenticated && <Sidebar isSidebar={isSidebar} />}
          <main className={isHangar1Route ? "full-screen-content" : "content"}>
            {!isLoginRoute && !isHangar1Route &&  !isxd && !isPorteriaRoute && !rankingProduccion && !isTransladoLaboratorio && !isCargamento && !isLavadoraRoute && !isTransEmpresa && !isInterfoliacion &&!isDescarga && !isSalida &&  !isTransladoChapa && !isSalaLimpia && !isCalandraTrue && !isCalandraDatosProductos&& !isHangar2Route && isAuthenticated && <Topbar setIsSidebar={setIsSidebar} />}
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<ProtectedRoute><Dracena /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/work" element={<ProtectedRoute><Work /></ProtectedRoute>} />
              <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
              <Route path="/contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>} />
              <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
              <Route path="/form" element={<ProtectedRoute><Form /></ProtectedRoute>} />
              <Route path="/registration" element={<ProtectedRoute><Registration /></ProtectedRoute>} />
              <Route path="/activity" element={<ProtectedRoute><Activity /></ProtectedRoute>} />
              <Route path="/owner" element={<ProtectedRoute><Owner /></ProtectedRoute>} />
              {/* <Route path="/owner/query" element={<ProtectedRoute><OwnerQuery /></ProtectedRoute>} /> */}
              <Route path="/queries" element={<ProtectedRoute><Queries /></ProtectedRoute>} />
              <Route path="/bar" element={<ProtectedRoute><Bar /></ProtectedRoute>} />
              <Route path="/pie" element={<ProtectedRoute><Pie /></ProtectedRoute>} />
              <Route path="/line" element={<ProtectedRoute><Line /></ProtectedRoute>} />
              <Route path="/faq" element={<ProtectedRoute><FAQ /></ProtectedRoute>} />
              <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
              <Route path="/geography" element={<ProtectedRoute><Geography /></ProtectedRoute>} />
              {/* <Route path="/Inventario" element={<ProtectedRoute><Inventario /></ProtectedRoute>} />
              <Route path="/Products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
              <Route path="/truks" element={<ProtectedRoute><Truks /></ProtectedRoute>} />
              <Route path="/hangar2" element={<ProtectedRoute><Hangar2 /></ProtectedRoute>} />
              <Route path="/hangar1" element={<ProtectedRoute><Hangar1 /></ProtectedRoute>} />
              <Route path="/porteria" element={<ProtectedRoute><Porteria /></ProtectedRoute>} />
              <Route path="/portero" element={<ProtectedRoute><Portero /></ProtectedRoute>} />
              <Route path="/camiones" element={<ProtectedRoute><Camiones /></ProtectedRoute>} /> */}
              <Route path="/resumen" element={<ProtectedRoute><Resumen /></ProtectedRoute>} />
              <Route path="/nomina" element={<ProtectedRoute><Nomina /></ProtectedRoute>} />
              <Route path="/registro/grupos" element={<ProtectedRoute><Grupos /></ProtectedRoute>} />
              <Route path="/registro/salarios" element={<ProtectedRoute><Salarios /></ProtectedRoute>} />
              <Route path="/registro/horarios" element={<ProtectedRoute><Horarios /></ProtectedRoute>} />
              <Route path="/lista/marcaciones" element={<ProtectedRoute><ListaMarcaciones /></ProtectedRoute>} />
              <Route path="/lista/marcacionesextras" element={<ProtectedRoute><ListaMarcacionesExtras /></ProtectedRoute>} />
              <Route path="/registro/descuento" element={<ProtectedRoute><RegistroDescuento /></ProtectedRoute>} />
              <Route path="/registro/adelanto" element={<ProtectedRoute><RegistroAdelanto /></ProtectedRoute>} />
              <Route path="/view/descuento" element={<ProtectedRoute><DescuentoView /></ProtectedRoute>} />
              <Route path="/view/horasExtras" element={<ProtectedRoute><HorasExtras /></ProtectedRoute>} />
              <Route path="/view/grupos" element={<ProtectedRoute><GruposView /></ProtectedRoute>} />
              <Route path="/view/horarios" element={<ProtectedRoute><HorariosView /></ProtectedRoute>} />
              <Route path="/view/salarios" element={<ProtectedRoute><Salariosview /></ProtectedRoute>} />
              <Route path="/view/usuarios" element={<ProtectedRoute><Usuarioview /></ProtectedRoute>} />
              <Route path="/registro/horasExtras" element={<ProtectedRoute><HorasExtrasR /></ProtectedRoute>} />
              <Route path="/view/plusView" element={<ProtectedRoute><PlusView /></ProtectedRoute>} />
              <Route path="/view/metasView" element={<ProtectedRoute><MetasView /></ProtectedRoute>} />
              <Route path="/registro/metas" element={<ProtectedRoute><MetasR /></ProtectedRoute>} />
              <Route path="/registro/calandra" element={<ProtectedRoute><Calandra /></ProtectedRoute>} />
              <Route path="/registro/fila" element={<ProtectedRoute><Fila /></ProtectedRoute>} />
              <Route path="/registro/columna" element={<ProtectedRoute><Columna /></ProtectedRoute>} />
              <Route path="/registro/estante" element={<ProtectedRoute><Estante /></ProtectedRoute>} />
              <Route path="/registro/interfoliacion" element={<ProtectedRoute><Interfoliacion /></ProtectedRoute>} />
              <Route path="/graficos" element={<ProtectedRoute><Graficos /></ProtectedRoute>} />
              <Route path="/relatorioG" element={<ProtectedRoute><RGraficos /></ProtectedRoute>} />
              <Route path="/view/reporteCalandra" element={<ProtectedRoute><ReporteCalandra /></ProtectedRoute>} />
              <Route path="/view/reporteDescarga" element={<ProtectedRoute><ReporteDescarga /></ProtectedRoute>} />
              <Route path="/view/reporteLavadora" element={<ProtectedRoute><ReporteLavadora /></ProtectedRoute>} />
              <Route path="/view/reporteSalaLimpia" element={<ProtectedRoute><ReporteSalaLimpia /></ProtectedRoute>} />
              <Route path="/registro/reporteStock" element={<ProtectedRoute><ReporteStock /></ProtectedRoute>} />
              <Route path="/registro/reporteCalandra" element={<ProtectedRoute><ReporteCalandrar /></ProtectedRoute>} />
              <Route path="/registro/reporteDescarga" element={<ProtectedRoute><ReporteDescargar/></ProtectedRoute>} />
              <Route path="/registro/reporteLavadora" element={<ProtectedRoute><ReporteLavadorar/></ProtectedRoute>} />
              <Route path="/registro/reporteSalaLimpia" element={<ProtectedRoute><ReporteSalaLimpiar/></ProtectedRoute>} />
              <Route path="/registro/reporteInterfoliacion" element={<ProtectedRoute><ReporteInterfoliacion/></ProtectedRoute>} />
              <Route path="/prod" element={<ProtectedRoute><ProduccionPie/></ProtectedRoute>} />
              <Route path="/view/calandraRegistro" element={<ProtectedRoute><CalandraRegistroView/></ProtectedRoute>} />
              <Route path="/registro/productos" element={<ProtectedRoute><Productos /></ProtectedRoute>} />
              <Route path="/registro/interfoliacion" element={<ProtectedRoute><InterfoliacionR /></ProtectedRoute>} />
              <Route path="/registro/interfoliacionMobile" element={<ProtectedRoute><InterfoliacionMobile /></ProtectedRoute>} />
              <Route path="/registro/aprovechamiento" element={<ProtectedRoute><Aprovechamiento /></ProtectedRoute>} />
              <Route path="/view/vistaStock" element={<ProtectedRoute><ReporteviewStock /></ProtectedRoute>} />
              <Route path="/view/vistaLavadoraCalandra" element={<ProtectedRoute><LavadoraCalandraView /></ProtectedRoute>} />
              <Route path="/view/vistaCalandraInterfoliacion" element={<ProtectedRoute><CalandraInterfoliacionView /></ProtectedRoute>} />
              <Route path="/view/reporteCalandra" element={<ProtectedRoute><ReporteviewCalandra /></ProtectedRoute>} />
              <Route path="/view/vistaInter" element={<ProtectedRoute><ReporteviewInter /></ProtectedRoute>} />
              <Route path="/view/ordenProduccionView" element={<ProtectedRoute><OrdenProduccionView /></ProtectedRoute>} />
              <Route path="/view/numeroSerie" element={<ProtectedRoute><NumeroSerie /></ProtectedRoute>} />
              <Route path="/view/stockview" element={<ProtectedRoute><StockView/></ProtectedRoute>} />
              <Route path="/view/stockMonoliticoview" element={<ProtectedRoute><StockMonoliticoView/></ProtectedRoute>} />
              <Route path="/view/stockLaminadoview" element={<ProtectedRoute><StockLaminadoView/></ProtectedRoute>} />
              <Route path="/registro/reporteStock" element={<ProtectedRoute><ReporteStock /></ProtectedRoute>} />
               <Route path="/registro/salidaProduct" element={<ProtectedRoute><SalidaProduct /></ProtectedRoute>} />
              <Route path="/registro/stock" element={<ProtectedRoute><Stock /></ProtectedRoute>} />
              <Route path="/registro/reporteInterfoliacion" element={<ProtectedRoute><ReporteInterfoliacion /></ProtectedRoute>} />
              <Route path="/registro/ventas" element={<ProtectedRoute><Ventas /></ProtectedRoute>} />              
              <Route path="/registro/ordenProduccion" element={<ProtectedRoute><OrdenProduccion /></ProtectedRoute>} />
              <Route path="/registro/proveedor" element={<ProtectedRoute><Proveedor /></ProtectedRoute>} />
              <Route path="/registro/pagos" element={<ProtectedRoute><Pagos/></ProtectedRoute>} />
              <Route path="/registro/permisos" element={<ProtectedRoute><Permisos/></ProtectedRoute>} />
              <Route path="/registro/permisosUsuario" element={<ProtectedRoute><PermisosUsuario/></ProtectedRoute>} />
              <Route path="/registro/notificacion" element={<ProtectedRoute><Notificación/></ProtectedRoute>} />
              <Route path="/registro/banco" element={<ProtectedRoute><Banco/></ProtectedRoute>} />
              <Route path="/view/aguinaldoIps" element={<ProtectedRoute><AguinaldoIps/></ProtectedRoute>} />
              <Route path="/view/aguinaldoInterno" element={<ProtectedRoute><AguinaldoInterno/></ProtectedRoute>} />
              <Route path="/view/pagos" element={<ProtectedRoute><PagosView/></ProtectedRoute>} />
              <Route path="/view/liquidation" element={<ProtectedRoute><LiquidationView/></ProtectedRoute>} />
              <Route path="/view/permisos" element={<ProtectedRoute><PermisosView/></ProtectedRoute>} />
              <Route path="/view/banco" element={<ProtectedRoute><BancoView/></ProtectedRoute>} />
              <Route path="/view/vacaciones" element={<ProtectedRoute><VacacionesView/></ProtectedRoute>} />
              <Route path="/view/adelanto" element={<ProtectedRoute><AdelantoView/></ProtectedRoute>} />
              <Route path="/lavadora" element={<ProtectedRoute><Lavadora/></ProtectedRoute>} />
              <Route path="/salaLimpia" element={<ProtectedRoute><SalaLimpia/></ProtectedRoute>} />
              <Route path="/calandraTrue" element={<ProtectedRoute><CalandraTrue/></ProtectedRoute>} />
              <Route path="/calandraDatosProductos" element={<ProtectedRoute><CalandraDatosProductos/></ProtectedRoute>} />
              <Route path="/registro/pvb" element={<ProtectedRoute><PVB /></ProtectedRoute>} />
              <Route path="/registro/vehiculo" element={<ProtectedRoute><Vehiculo /></ProtectedRoute>} />
              <Route path="/registro/caballete" element={<ProtectedRoute><Caballete /></ProtectedRoute>} />
              <Route path="/registro/cliente" element={<ProtectedRoute><Cliente /></ProtectedRoute>} />
              <Route path="/registro/entradaNotaFiscal" element={<ProtectedRoute><EntradaNotaFiscal /></ProtectedRoute>} />
              <Route path="/registro/pvbNotaFiscal" element={<ProtectedRoute><PvbNotaFiscal /></ProtectedRoute>} />
              <Route path="/view/liberarStock" element={<ProtectedRoute><LiberarStock/></ProtectedRoute>} />
              <Route path="/view/notasFiscalesView" element={<ProtectedRoute><NotasFiscales/></ProtectedRoute>} />
              <Route path="/view/stockPvb" element={<ProtectedRoute><StockPVBView/></ProtectedRoute>} />
              <Route path="/view/swapHistory" element={<ProtectedRoute><SwapHistoryView /></ProtectedRoute>} />
              <Route path="/view/rpInterBase64" element={<ProtectedRoute><AntiguoRp/></ProtectedRoute>} />
              <Route path="/view/translados" element={<ProtectedRoute><Translados/></ProtectedRoute>} />
              <Route path="/view/translados" element={<ProtectedRoute><Translados/></ProtectedRoute>} />
              <Route path="/registro/transladoChapas" element={<ProtectedRoute><TransladoChapas/></ProtectedRoute>} />
              {/* <Route path="/registro/quiebra" element={<ProtectedRoute><Quiebra /></ProtectedRoute>} /> */}
              <Route path="/registro/transferenciaEmpresas" element={<ProtectedRoute><Transferencia /></ProtectedRoute>} />
              <Route path="/registro/accesoEventos" element={<ProtectedRoute><AccesoEventos /></ProtectedRoute>} />
              <Route path="/registro/receta" element={<ProtectedRoute><Receta/></ProtectedRoute>} />
              <Route path="/registro/autoClave" element={<ProtectedRoute><AutoClave/></ProtectedRoute>} />
              <Route path="/registro/salidaAutoclave" element={<ProtectedRoute><SalidaAutoClave/></ProtectedRoute>} />
              <Route path="/view/quiebra" element={<ProtectedRoute><QuiebraV/></ProtectedRoute>} />
              <Route path="/registro/sala" element={<ProtectedRoute><SalaLimpiaT/></ProtectedRoute>} />
              <Route path="/view/sala" element={<ProtectedRoute><SalaLimpiaView/></ProtectedRoute>} />
              <Route path="/view/exportacionZd" element={<ProtectedRoute><ExportacionZD/></ProtectedRoute>} />
              <Route path="/view/exportacionA" element={<ProtectedRoute><ExportacionA/></ProtectedRoute>} />
              <Route path="/view/historial" element={<ProtectedRoute><Historial/></ProtectedRoute>} />
              <Route path="/view/liberarFinanciero" element={<ProtectedRoute><LiberarFinanciero/></ProtectedRoute>} />
              <Route path="/view/liberarCamiones" element={<ProtectedRoute><LiberarCamiones/></ProtectedRoute>} />
              <Route path="/view/ordenCarga" element={<ProtectedRoute><OrdenCarga/></ProtectedRoute>} />
              <Route path="/view/ordenCargaListado" element={<ProtectedRoute><OrdenCargaListado/></ProtectedRoute>} />
              <Route path="/view/ordenCarga/:id" element={<ProtectedRoute><OrdenCargaDetalle/></ProtectedRoute>} />
              <Route path="/view/cargamento" element={<ProtectedRoute><Cargamento/></ProtectedRoute>} />
              <Route path="/view/contratos" element={<ProtectedRoute><Contratos/></ProtectedRoute>} />
              {/* <Route path="/registro/ventas" element={<ProtectedRoute><Ventas /></ProtectedRoute>} /> */}
              <Route path="/registro/quiebra" element={<ProtectedRoute><DndProvider backend={HTML5Backend}><Quiebra/></DndProvider></ProtectedRoute>}/>
              <Route path="/registro/descarga" element={<ProtectedRoute><Descarga /></ProtectedRoute>} />
              <Route path="/registro/pedidoVenta" element={<ProtectedRoute><PedidoVenta /></ProtectedRoute>} />
              <Route path="/registro/precio" element={<ProtectedRoute><Precio/></ProtectedRoute>} />
              <Route path="/view/precio" element={<ProtectedRoute><PrecioView/></ProtectedRoute>} />
              <Route path="/view/exportacionVentana" element={<ProtectedRoute><ExportacionVentana/></ProtectedRoute>} />
              <Route path="/view/palitero" element={<ProtectedRoute><Palitero/></ProtectedRoute>} />
              <Route path="/view/reembalar" element={<ProtectedRoute><Reembalar/></ProtectedRoute>} />
              <Route path="/view/historialChapa" element={<ProtectedRoute><HistorialChapa/></ProtectedRoute>} />
              <Route path="/view/historialVentas" element={<ProtectedRoute><HistorialVentas/></ProtectedRoute>} />
              <Route path="/view/stockCaballete" element={<ProtectedRoute><StockCaballete/></ProtectedRoute>} />
              <Route path="/view/listaProducto" element={<ProtectedRoute><ListaProducto/></ProtectedRoute>} />
              <Route path="/view/stockCoinvertir" element={<ProtectedRoute><StockCoinvertir/></ProtectedRoute>} />
              <Route path="/registros/productostejidos" element={<ProtectedRoute><ProductosTejidos/></ProtectedRoute>} />
              <Route path="/registros/maquinastejido" element={<ProtectedRoute><MaquinasTejido/></ProtectedRoute>} />
              <Route path="/registros/stocktejido" element={<ProtectedRoute><StockTejido/></ProtectedRoute>} />
              <Route path="/consultas/tejidoespera" element={<ProtectedRoute><TejidoEspera/></ProtectedRoute>} />
              <Route path="/traslado/tejidoespera" element={<ProtectedRoute><TrasladoTejido/></ProtectedRoute>} />
              <Route path="/registros/pedidoventa" element={<ProtectedRoute><PedidoVentaTejido/></ProtectedRoute>} />
              <Route path="/view/CargamentoTejido" element={<ProtectedRoute><CargamentoTejido/></ProtectedRoute>} />
              <Route path="/view/LiberarTejido" element={<ProtectedRoute><LiberarTejido/></ProtectedRoute>} />
              <Route path="/consultas/tejidoenstock" element={<ProtectedRoute><TejidoenStock/></ProtectedRoute>} />
              <Route path="/view/historialVentasTejido" element={<ProtectedRoute><HistorialVentasTejido/></ProtectedRoute>} />
              <Route path="/consultas/rollosgeneral" element={<ProtectedRoute><RolloGeneral/></ProtectedRoute>} />
              <Route path="/registro/transladoLaboratorio" element={<ProtectedRoute><TransladoLaboratorio/></ProtectedRoute>} />
              <Route path="/consultas/stockEvoluaco" element={<ProtectedRoute><StockEvoluaco/></ProtectedRoute>} />
              <Route path="/registros/productosamoxarifado" element={<ProtectedRoute><ProductosAmoxarifado/></ProtectedRoute>} />
              <Route path="/registros/categoriasamoxarifado" element={<ProtectedRoute><Categoriasamoxarifado/></ProtectedRoute>} />
              <Route path="/registros/subcategoriasamoxarifado" element={<ProtectedRoute><SubCategoriasamoxarifado/></ProtectedRoute>} />
              <Route path="/registros/depositosamoxarifado" element={<ProtectedRoute><Depositosamoxarifado/></ProtectedRoute>} />
              <Route path="/registros/stockDeposito" element={<ProtectedRoute><StockDeposito/></ProtectedRoute>} />
              <Route path="/registros/devolucionDeposito" element={<ProtectedRoute><DevolucionDeposito/></ProtectedRoute>} />
              <Route path="/consultas/produccion" element={<ProtectedRoute><ProduccionTejido/></ProtectedRoute>} />
              <Route path="/consultas/produccionfuncionarios" element={<ProtectedRoute><ProduccionFuncTejido/></ProtectedRoute>} />
              <Route path="/consultas/productosamoxarifado" element={<ProtectedRoute><ProductosViewAmoxarifado/></ProtectedRoute>} />
              <Route path="/registros/produccion" element={<ProtectedRoute><ProduccionRolos/></ProtectedRoute>} />
              <Route path="/registros/ordenTejido" element={<ProtectedRoute><OrdenTejido/></ProtectedRoute>} />
              <Route path="/registro/fila" element={<ProtectedRoute><Fila/></ProtectedRoute>} />
              <Route path="/registro/estante" element={<ProtectedRoute><Estante/></ProtectedRoute>} />
              <Route path="/registro/columna" element={<ProtectedRoute><Columna/></ProtectedRoute>} />
              <Route path="/registros/editarproductos" element={<ProtectedRoute><EditProducto/></ProtectedRoute>} />
              <Route path="/consultas/stockamoxarifado" element={<ProtectedRoute><StockAmoxarifado/></ProtectedRoute>} />
              <Route path="/consultas/prestamoamoxarifado" element={<ProtectedRoute><PrestamoAmoxarifado/></ProtectedRoute>} />
              <Route path="/consultas/historialDeposito" element={<ProtectedRoute><HistorialDeposito/></ProtectedRoute>} />
              <Route path="/consultas/stockMinimo" element={<ProtectedRoute><StockMinimoAmoxarifado/></ProtectedRoute>} />
              <Route path="/view/stockMonoliticoVentasview" element={<ProtectedRoute><StockMonoliticoVentasView/></ProtectedRoute>} />
              <Route path="/view/stockLaminadoVentaview" element={<ProtectedRoute><StockLaminadoVentaView/></ProtectedRoute>} />
              <Route path="/registro/asignacionChapa" element={<ProtectedRoute><Cargadoresxdxd/></ProtectedRoute>} />
              <Route path="/view/resumenAdelanto" element={<ProtectedRoute><ResumenAdelanto/></ProtectedRoute>} />
              <Route path="/feriados" element={<ProtectedRoute><Feriados /></ProtectedRoute>} />
              <Route path="/view/adicional" element={<ProtectedRoute><Adicional/></ProtectedRoute>} />
              <Route path="/view/truck" element={<ProtectedRoute><Truck/></ProtectedRoute>} />
              <Route path="/view/rankingProduccion" element={<RankingProduccion/>} />
              <Route path="/registro/catalogoPruebasLaboratorio" element={<ProtectedRoute><LaboratorioPruebas/></ProtectedRoute>} />
              <Route path="/registro/resultadosLaboratorio" element={<ProtectedRoute><LaboratorioResultados/></ProtectedRoute>} />
              <Route path="/view/resultadosLaboratorio" element={<ProtectedRoute><LaboratorioResultadosVista/></ProtectedRoute>} />
              <Route path="/view/stockLaminadoExport" element={<ProtectedRoute><StockLamExport/></ProtectedRoute>} />
              <Route path="/registration/faltas" element={<ProtectedRoute><Faltas/></ProtectedRoute>} />
              <Route path="/view/faltas" element={<ProtectedRoute><FaltasView/></ProtectedRoute>} />
              <Route path="/view/autoclave" element={<ProtectedRoute><AutoClaveView/></ProtectedRoute>} />
              <Route path="/registration/plus" element={<ProtectedRoute><RegistroPlus/></ProtectedRoute>} />
              <Route path="/registro/patrimonio" element={<ProtectedRoute><Patrimonios/></ProtectedRoute>} />
              <Route path="/registro/postulantes" element={<ProtectedRoute><CvPostulante/></ProtectedRoute>} />
              <Route path="/view/postulantes" element={<ProtectedRoute><CvPostulanteView/></ProtectedRoute>} />
              <Route path="/registro/uniformes" element={<ProtectedRoute><RegistroUniforme/></ProtectedRoute>} />
              <Route path="/registro/stockuniformes" element={<ProtectedRoute><RegistroStockUniforme/></ProtectedRoute>} />
              <Route path="/view/stockuniformes" element={<ProtectedRoute><StockUniformesV/></ProtectedRoute>} />
              <Route path="/view/topuniformes" element={<ProtectedRoute><TopUniformes/></ProtectedRoute>} />
              <Route path="/view/historialAsignacion" element={<ProtectedRoute><HistorialAsignacionU/></ProtectedRoute>} />
              <Route path="/view/uniformes" element={<ProtectedRoute><Uniformes/></ProtectedRoute>} />
              <Route path="/view/acceso" element={<ProtectedRoute><AccesoPage/></ProtectedRoute>} />

            </Routes>
          </main>
        </div>
        <ToastContainer/>
        </FeriadosProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
    
  );
}

export default App;

